<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <b-row>
        <b-col cols="12" md="10" lg="8">
          <IncidentForm
            :data="formData"
            :errors="formErrors"
            :editing="isEditing"
            :assessor-select-options="assessorOptions"
            :type-select-options="typeOptions"
            @update="updateForm"
          />
        </b-col>
      </b-row>

      <div v-if="!isEditing">
        <BfButton @click="storeIncidencia">Guardar</BfButton>
      </div>
    </template>
  </PageWrap>
</template>

<script>
import IncidentForm from '@/components/FormGroups/IncidentForm';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import { chargeAPI, incidentAPI } from '@/api';
import { mapState } from 'vuex';
import get from 'lodash.get';

export default {
  name: 'IncidentsDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    const { chargeId = '' } = this.$route.query;

    return {
      chargeId,
      formData: {},
      formErrors: {},
      loadingData: false,
      assessorOptions: [],
      typeOptions: [],
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        console.log('Estamos editando');
        await this.loadData();
      } else {
        if (!!this.chargeId === false) {
          this.$router.replace({ name: 'incidencias' });
        }
        await this.prepareForm();
        await this.getChargeData();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async storeIncidencia() {
      this.formData.tasador_abre_id = this.tasadorId;
      this.formData.encargos_id = this.chargeId;

      try {
        this.formErrors = {};
        const { data, message } = await incidentAPI.create(this.formData);
        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({ name: 'incidencia', params: { id: `${data.id}` } });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({ title: 'Error', message: 'Existe un error con tus datos', type: 'error' });
      }
    },

    async loadData() {
      const { data, tasadores, tipos } = await incidentAPI.get(this.id);
      console.log(`id${data}`);
      this.formData = data;
      this.setassessorOptions(tasadores);
      this.setTypeOptions(tipos);
      console.log(this.formData);
    },

    async prepareForm() {
      const { data, tasadores, tipos } = await incidentAPI.preCreate();

      this.formData = { ...this.formData, ...data };
      this.setassessorOptions(tasadores);
      this.setTypeOptions(tipos);
    },

    async getChargeData() {
      const {
        data: [charge],
      } = await chargeAPI.get(this.chargeId);

      this.formData = {
        ...this.formData,
        encargos_numero: charge.numero_encargo,
        encargos_empresa_cliente_nombre: charge.empresa_cliente_nombre,
      };
    },

    setassessorOptions(data) {
      this.assessorOptions = data.map(({ clave, id }) => ({ label: clave, value: id }));
    },

    setTypeOptions(data) {
      this.typeOptions = data.map(type => ({ label: type, value: type }));
    },

    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await incidentAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },
  },

  computed: {
    ...mapState({ tasadorId: ({ auth }) => get(auth, ['user', 'tasador_id']) }),

    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing ? `Incidencia del encargo: ${this.formData.encargos_codigo || ''}` : 'Crear Incidencia';
    },
  },

  components: {
    IncidentForm,
    LoadingIndicator,
    PageWrap,
  },
};
</script>
